var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tnc d-flex flex-column align-items-center"},[_c('h2',{attrs:{"align":"center"}},[_vm._v("商戶中心使用條款與細則")]),_c('br'),_c('TNCText',{staticClass:"tnc-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }